var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bank 3 logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7495 29.7509V23.7509C28.8173 23.7509 30.4995 22.0686 30.4995 20.0009C30.4995 17.9331 28.8173 16.2509 26.7495 16.2509C24.6818 16.2509 22.9995 17.9331 22.9995 20.0009H16.9995C16.9995 14.6249 21.3735 10.2509 26.7495 10.2509C32.1255 10.2509 36.4995 14.6249 36.4995 20.0009C36.4995 25.3769 32.1255 29.7509 26.7495 29.7509Z",
    fill: "#42D778"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2495 29.7509C7.87351 29.7509 3.49951 25.3769 3.49951 20.0009C3.49951 14.6249 7.87351 10.2509 13.2495 10.2509V16.2509C11.1818 16.2509 9.49951 17.9331 9.49951 20.0009C9.49951 22.0686 11.1818 23.7509 13.2495 23.7509C15.3173 23.7509 16.9995 22.0686 16.9995 20.0009H22.9995C22.9995 25.3769 18.6255 29.7509 13.2495 29.7509Z",
    fill: "#42D778"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7496 29.7509C21.3736 29.7509 16.9996 25.3769 16.9996 20.0009C16.9996 17.9331 15.3174 16.2509 13.2496 16.2509V10.2509C18.6256 10.2509 22.9996 14.6249 22.9996 20.0009C22.9996 22.0686 24.6819 23.7509 26.7496 23.7509V29.7509Z",
    fill: "#42D778"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4827 16.4856C24.9112 14.4981 23.8732 12.7079 22.4887 11.2446C21.5685 11.6946 20.73 12.2796 19.9995 12.9816C21.8452 14.7554 22.9995 17.2431 22.9995 20.0001C22.9995 18.3801 24.0397 17.0091 25.4827 16.4856ZM14.4952 23.5214C15.0682 25.5096 16.1152 27.2976 17.5027 28.7609C18.4305 28.3079 19.278 27.7176 20.013 27.0081C18.165 25.2344 16.9995 22.7586 16.9995 20.0009C16.9995 21.6299 15.9495 23.0054 14.4952 23.5214Z",
    fill: "#BBF1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank3);
export default __webpack_public_path__ + "static/media/bank3.4846d80cafcb9f95a76ec3561e18ba06.svg";
export { ForwardRef as ReactComponent };